import { Component, input } from '@angular/core';

@Component({
  selector: 'app-checkmark',
  imports: [],
  templateUrl: './checkmark.component.html',
  styleUrl: './checkmark.component.css'
})
export class CheckmarkComponent {
  checked = input.required<boolean>();
}
